module.exports = __webpack_public_path__ + "static/media/aaha.0004cf5c.ogg";